import { getOrdersOrderIdPrice } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { useQuery } from "@tanstack/react-query";

export const getOrderPriceByOrderIdQueryKey = (orderId: number) => {
	return ["ORDER_PRICE_BY_ORDER_ID", orderId];
};

export function useGetOrderPriceByOrderIdQuery(orderId?: number) {
	return useQuery({
		queryKey: getOrderPriceByOrderIdQueryKey(orderId!),
		queryFn: processResponse(() => getOrdersOrderIdPrice(orderId!)),
		retry: false,
		retryOnMount: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!orderId && hasPermission(UserPermissions.OrderPriceModule.read),
	});
}
